@import "../../../../common/base";
@import "../../../../common/icons";

@include button-reset();
@include box-sizing();

:host,
.group {
  display: grid;
  grid-template-rows: min-content;
}

.action {
  &::before {
    content: "";
    inline-size: var(--ch-action-list-group__expandable-button-size);
    block-size: var(--ch-action-list-group__expandable-button-size);
    background-color: currentColor;
    -webkit-mask: no-repeat center /
      var(--ch-action-list-group__expandable-button-image-size) $expandable-icon;
  }

  &--collapsed::before {
    transform: rotate(-90deg); // TODO: Add RTL support
  }
}

// - - - - - - - - - - - - - - - -
//       Expandable content
// - - - - - - - - - - - - - - - -
.expandable {
  display: grid;
  grid-auto-rows: min-content;
  position: relative;
  padding: 0;
  margin: 0;

  &--lazy-loaded {
    content-visibility: auto;
    contain-intrinsic-size: auto 100px;
  }
}

.expandable--collapsed {
  display: none;
  overflow: hidden;
}
